<template>
  <Page>
    <section class="applogs-container">
      <Announce style="margin-top: 8px;" />
      <Breadcrumb title="任务中心" />
      <ListFilter :formList="filterFormList" @search="searchHandle" />
      <div class="logs-list">
        <el-table :data="list" style="width: 100%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
          <template #empty><Empty style="margin-top: 56px;" /></template>
          <el-table-column fixed prop="traceId" label="计划ID" width="208" />
          <el-table-column prop="createName" label="用户名称" width="108" show-overflow-tooltip />
          <el-table-column prop="channelName" label="应用" width="208" show-overflow-tooltip />
          <el-table-column prop="accountNames" label="船司账号" width="338">
            <template #default="scope">
              <span>{{ scope.row.accountNames.join('、')  }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="paramsTemplateName" label="参数模板" width="208" show-overflow-tooltip />
          <el-table-column prop="originalFileName" label="初始上传文件" width="208" show-overflow-tooltip />
          <el-table-column prop="remark" label="备注" width="208" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="156">
            <template #default="scope">
              <span class="statusitem"><em :style="{ backgroundColor: CONST.TASK_STATUS_COLOR[scope.row.status] }" />{{ CONST.TASK_STATUS_LABEL[scope.row.status] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="executeTime" label="执行时间" width="208">
            <template #default="scope">
              <div class="executetime-wrap">
                <span>{{ scope.row.executeTime && momemt(scope.row.executeTime).format('YYYY MM.DD HH:mm') || '-' }}</span>
                <el-popover
                  placement="bottom"
                  :title="`每隔${scope.row.frequency}分钟执行`"
                  :width="180"
                  trigger="hover"
                  popper-class="planned-executetime-wrap"
                >
                  <template #reference>
                    <el-icon v-if="scope.row.executeTime" style="margin-left: 4px; margin-top: -1px;"><Clock /></el-icon>
                  </template>
                  <template #default>
                    <div class="planned-executetime-list">
                      <span class="item" v-for="(item, index) in scope.row?.nextFiveExecuteTimes.slice(0, 5)">{{ item && momemt(item).format('YYYY MM.DD HH:mm') || '-' }}</span>
                      <span class="item" v-if="scope.row?.nextFiveExecuteTimes.length > 5">……</span>
                    </div>
                  </template>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建时间" width="208">
            <template #default="scope">
              <span>{{ scope.row.createdTime && momemt(scope.row.createdTime).format('YYYY MM.DD HH:mm') || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updatedTime" label="更新时间" width="208">
            <template #default="scope">
              <span>{{ scope.row.updatedTime && momemt(scope.row.updatedTime).format('YYYY MM.DD HH:mm') || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="edit" label="操作" fixed="right" width="208" align="right">
            <template #default="scope">
              <el-button link type="primary" @click="editHandle(scope.row)" v-if="scope.row.canUpdate">编辑</el-button>
              <el-button link type="primary" @click="recordHandle(scope.row)">记录</el-button>

              <el-popconfirm title="你确定要关闭任务吗?" width="208px" v-if="[ CONST.TASK_STATUS_RUNNING, CONST.TASK_STATUS_STARTED ].includes(scope.row.status)">
                <template #reference>
                  <el-button link type="primary">关闭</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button @click="cancel" size="small">取消</el-button>
                  <el-button type="primary" size="small" @click="closeHandle(scope.row, confirm)">确定</el-button>
                </template>
              </el-popconfirm>
              <el-popconfirm title="你确定要开启任务吗?" width="208px" v-if="[ CONST.TASK_STATUS_UNUSUAL, CONST.TASK_STATUS_CLOSED ].includes(scope.row.status)">
                <template #reference>
                  <el-button link type="primary">开启</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button @click="cancel" size="small">取消</el-button>
                  <el-button type="primary" size="small" @click="startHandle(scope.row, confirm)">确定</el-button>
                </template>
              </el-popconfirm>

              <el-popconfirm title="确认后，初始上传文件将自动下载至电脑。" width="208px">
                <template #reference>
                  <el-button link type="primary">文件</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button @click="cancel" size="small">取消</el-button>
                  <el-button type="primary" size="small" @click="fileDownloadHandle(scope.row, confirm)">确定</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <Spagination
          wstyle="margin-top: 24px"
          :page="page"
          :size="size"
          :total="total"
          @current-change="val => page = val"
        />
      </div>
    </section>

    <OrderConfig v-if="taskEditFlag" mode="edit" :executeType="2" :data="taskData" @cancel="cancelEditHandle" @refresh="getList" />
    <OrderConfigNotification />
  </Page>

  <el-dialog v-model="detailFlag" title="详情" width="83%">
    <el-table :data="detailList" style="width: 100%; height: 80%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
      <template #empty><Empty style="margin-top: 56px;" /></template>
      <el-table-column prop="traceId" label="子任务ID" width="200" />
      <el-table-column prop="paramsCore" label="核心参数" />
      <el-table-column prop="resultCore" label="核心结果" />
      <el-table-column prop="status" label="状态" width="128px">
        <template #default="scope">
          <span class="statusitem"><em :style="{ backgroundColor: CONST.SUB_LOGS_STATUS_COLOR[scope.row.status] }" />{{ CONST.SUB_LOGS_STATUS_LABEL[scope.row.status] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rt" label="用时（秒）"></el-table-column>
      <el-table-column prop="machineName" label="执行机器"></el-table-column>
      <el-table-column prop="createdTime" label="开始时间">
        <template #default="scope">
          <span>{{ scope.row.createdTime && momemt(scope.row.createdTime).format('YYYY MM.DD HH:mm') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedTime" label="结束时间">
        <template #default="scope">
          <span>{{ scope.row.updatedTime && momemt(scope.row.updatedTime).format('YYYY MM.DD HH:mm') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Spagination
      :page="detailPage"
      :size="detailSize"
      :total="detailTotal"
      @current-change="val => detailPage = val"
    />
  </el-dialog>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import momemt from 'moment'
  import { Clock } from '@element-plus/icons-vue'

  import * as Request from '@/assets/request';
  import * as CONST from '@/assets/const';
  import * as Utils from '@/assets/utils';

  import Announce from '@/components/announce';
  import OrderConfig from '@/pages/dispatch/components/orderconfig'
  import OrderConfigNotification from '@/pages/dispatch/components/orderconfig/notification.vue';
  import Empty from '@/components/empty';
  import Page from '@/components/page';
  import Breadcrumb from '@/components/breadcrumb';
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import { ElMessage } from 'element-plus';
  import { useRouter, useRoute } from 'vue-router';
  const router = useRouter();

  /**
   * 筛选
   */
  const filterFormList = ref([])
  const filterFormListInit = async () => {
    filterFormList.value = [
      {
        type: 'select', field: 'appGroupId',
        label: '船司助手', placeholder: '请选择',
        options: []
      },
      {
        type: 'select', field: 'appIds', multiple: true, collapseTags: true,
        label: '应用名称', placeholder: '请选择',
        options: []
      },
      {
        type: 'select', field: 'status',
        label: '状态', placeholder: '请选择',
        options: Object.keys(CONST.TASK_STATUS_LABEL).map(value => ({ value: Number(value), label: CONST.TASK_STATUS_LABEL[value] }))
      },
    ]
  }
  onMounted(() => {
    filterFormListInit()
  })
  // 获取所有app
  const getAllApp = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/getAllApp'
    });
    if(result?.code != 200) return;

    let appIdOptions = [];
    let appGroupIdOptions = [];
    if(result?.data?.length > 0) {
      result.data.map(item => {
        console.log('item', item)
        if(item.apps?.length > 0) {
          item.apps.map(_item => {
            appIdOptions.push({ value: _item?.id, label: _item?.name })
          })
        }
        appGroupIdOptions.push({ value: item?.group?.id, label: item?.group?.name })
      })
    }
    console.log('appGroupIdOptions', appGroupIdOptions, 'appIdOptions', appIdOptions)
    filterFormList.value.map(item => {
      if(item?.field == 'appIds') {
        item.options = appIdOptions.filter(item => specificAppIds.includes(item.value))
      }
      if(item?.field == 'appGroupId') {
        item.options = appGroupIdOptions
      }
      return item;
    })

    console.log('filterFormList', filterFormList.value)
  }
  onMounted(() => {
    getSpecificAppIds().then(() => {
      getAllApp(),
      getList()
    })
  })

  // 获取特殊需要过滤的appId
  let specificAppIds = []
  const getSpecificAppIds = () => Request.post({
    url: '/22001/facade/dispatch/getSpecificAppIds'
  }).then(res => {
    if(res?.code != 200) return;
    specificAppIds = res.data
  })

  /**
   * 列表
   */
  const list = ref([])
  const listQuery = ref({})
  const total = ref(0)
  const size = ref(50)
  const page = ref(1)
  const getList = async () => {
    const params = {
      ...listQuery.value,
      page: page.value,
      size: size.value,
    }
    if (!params.appIds || params.appIds.length === 0) {
      params.appIds = specificAppIds
    }
    const result = await Request.post({
      url: '/22001/facade/planned/task/searchList',
      data: params
    });
    if(result?.code != 200) return;

    list.value = result.data.content;
    total.value = result.data.total;
  }

  watch(() => [ listQuery.value, page.value ], () => {
    getList();
  }, { deep: true })

  // 搜索
  const searchHandle = data => {
    listQuery.value = {...data};
    page.value = 1;
  }

  /**
   * 操作
   */
  // 编辑
  const taskData = ref(null);
  const taskEditFlag = ref(false);
  const editHandle = (target) => {
    taskEditFlag.value = true;
    setTimeout(() => {
      taskData.value = {
        name: `编辑“${target?.channelName}”`,
        ...target
      };
    }, 20)
  }
  const cancelEditHandle = () => {
    taskData.value = null;
    taskEditFlag.value = false;
  }

  // 记录
  const recordHandle = (item) => {
    router.push(`/custom-logs?timerTaskId=${item?.traceId}`);
  }

  // 关闭
  const closeHandle = async (item, confirm) => {
    const result = await Request.post({
      url: '/22001/facade/planned/task/close',
      data: item?.id
    });
    if(result?.code != 200) return;
    ElMessage.success('任务已关闭');

    confirm()
    getList();
  }

  // 开启
  const startHandle = async (item, confirm) => {
    const result = await Request.post({
      url: '/22001/facade/planned/task/enable',
      data: item?.id
    });
    if(result?.code != 200) return;
    ElMessage.success('任务已开启');

    confirm();
    getList();
  }

  // 文件
  const fileDownloadHandle = (item) => {
    window.open(item?.fileUrl);
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>

<style lang="less">
  .planned-executetime-wrap{
    display: block;
    .el-popover__title{
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: #232326;
      border-bottom: 1px solid #F8F9FA;
      padding-bottom: 12px;
      box-sizing: border-box;
    }
    .planned-executetime-list{
      display: flex;
      flex-direction: column;
      gap: 8px;
      max-height: 250px;
      overflow: auto;
      >.item{
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #515358;
        display: flex;
        align-items: center;
      }
    }
  }</style>
